module.exports = __webpack_public_path__ + "static/dge-6032f60c0a3d99f3ee007538fd20bc5a.png";